"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _NumberAndUnitWithOptions = _interopRequireDefault(require("../NumberAndUnitWithOptions"));

var _SingleChoiceOrCustom = require("../SingleChoiceOrCustom");

var _DiagnosticButtons = require("../DiagnosticButtons");

var _DiagnosticSlider = require("../DiagnosticSlider");

var _MultipleChoice = require("../MultipleChoice");

var _MultipleInputs = require("../MultipleInputs");

var _LocationInput = require("../LocationInput");

var _FormWithInputs = _interopRequireDefault(require("../FormWithInputs"));

var _SingleLineText = _interopRequireDefault(require("../SingleLineText"));

var _SingleChoice = require("../SingleChoice");

var _RangeSlider = require("../RangeSlider");

var _SingleLine = require("../SingleLine");

var _DateSelect = require("../DateSelect");

var _SinglePhone = _interopRequireDefault(require("../SinglePhone"));

var _DropDown = require("../DropDown");

var _Location = require("../Location");

var _LongText = require("../LongText");

var _SignUp = _interopRequireDefault(require("../SignUp"));

var _jsxRuntime = require("react/jsx-runtime");

var SelectComponent = function SelectComponent(_ref) {
  var componentConfiguration = _ref.componentConfiguration;
  var key = componentConfiguration.identifier || componentConfiguration.valueName;

  switch (componentConfiguration.component) {
    case 'MultipleChoice':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_MultipleChoice.MultipleChoice, {
        config: componentConfiguration
      }, key);

    case 'MultipleInputs':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_MultipleInputs.MultipleInputs, {
        config: componentConfiguration
      }, key);

    case 'SingleChoice':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SingleChoice.SingleChoice, {
        config: componentConfiguration
      }, key);

    case 'SingleChoiceOrCustom':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SingleChoiceOrCustom.SingleChoiceOrCustom, {
        config: componentConfiguration
      }, key);

    case 'LongText':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_LongText.LongText, {
        config: componentConfiguration
      }, key);

    case 'Location':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Location.Location, {
        config: componentConfiguration
      }, key);

    case 'LocationInput':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_LocationInput.LocationInput, {
        config: componentConfiguration
      }, key);

    case 'RangeSlider':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_RangeSlider.RangeSlider, {
        config: componentConfiguration
      }, key);

    case 'DropDown':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_DropDown.DropDown, {
        config: componentConfiguration
      }, key);

    case 'DiagnosticSlider':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_DiagnosticSlider.DiagnosticSlider, {
        config: componentConfiguration
      }, key);

    case 'DiagnosticButtons':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_DiagnosticButtons.DiagnosticButtons, {
        config: componentConfiguration
      }, key);

    case 'DateSelect':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_DateSelect.DateSelect, {
        config: componentConfiguration
      }, key);

    case 'SingleLine':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SingleLine.SingleLine, {
        config: componentConfiguration
      }, key);

    case 'SingleLineText':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SingleLineText.default, {
        config: componentConfiguration
      }, key);

    case 'SinglePhone':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SinglePhone.default, {
        config: componentConfiguration
      }, key);

    case 'SignUp':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SignUp.default, {
        config: componentConfiguration
      }, key);

    case 'NumberAndUnitWithOptions':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_NumberAndUnitWithOptions.default, {
        config: componentConfiguration
      }, key);

    case 'FormWithInputs':
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormWithInputs.default, {
        config: componentConfiguration
      }, key);

    default:
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        children: ["Default: ", componentConfiguration.component]
      }, key);
  }
};

var _default = SelectComponent;
exports.default = _default;